import { tracker } from '@lessonup/analytics';
import { setUser } from '@lessonup/intercom-classic';
import { logger } from '@lessonup/logging-classic';
import { IntercomData, Language, UserContext } from '@lessonup/typescript-core/domain';

export function syncUserToIntercom(user: UserContext, userHash: string) {
  const userDataForIntercom = IntercomData.userDataForContext(user);

  if (!user || !userDataForIntercom || !tracker.cookieSettings()?.analytic) return;

  try {
    const { user_id, ...userData } = userDataForIntercom;

    setUser({
      ...userData,
      id: user_id,
      language: Language.fallbackForLanguage(user.language),
      hash: userHash,
    });
  } catch (error) {
    logger.error('Could not fetch user hash', error);
  }
}
